// Visible thumbnails share a bounded queue; completed bytes are never cached.
export function createArtworkAssetQueue(limit=3,maxPending=64) {
  let active=0
  const pending=[]
  const cancelled=()=>new DOMException('Preview cancelled','AbortError')
  const advance=()=>{
    while(active<limit&&pending.length){
      const entry=pending.shift(),{run,signal,resolve,reject}=entry
      signal?.removeEventListener('abort',entry.cancel)
      if(signal?.aborted){reject(cancelled());continue}
      active++
      Promise.resolve().then(()=>{if(signal?.aborted)throw cancelled();return run()}).then(resolve,reject).finally(()=>{active--;advance()})
    }
  }
  return (run,signal)=>new Promise((resolve,reject)=>{
    if(signal?.aborted){reject(cancelled());return}
    if(pending.length>=maxPending){reject(Error('Preview queue full; re-enter the viewport to retry'));return}
    const entry={run,signal,resolve,reject,cancel:()=>{const index=pending.indexOf(entry);if(index>=0){pending.splice(index,1);reject(cancelled())}}}
    signal?.addEventListener('abort',entry.cancel,{once:true});pending.push(entry);advance()
  })
}
